<template>
  <div>
    <page-title icon="fas fa-table" main="Relatórios" sub="Cultura Por Estados" :help="true"
      titleHelp="Ajuda - Carteira de Clientes" content=".">
    </page-title>
    <card>
      <div class="row gy-4">
        <div class="col p-4">
          <div slot="header" class="row align-items-center">
            <div class="col">
              <h5 class="h3 mb-0">Potencial de Cultura Por Estados</h5>
              <h6 class="text-uppercase text-muted ls-1 mb-1">
                Selecione no mapa a região na qual deseja visualizar os dados
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <anosafra-multiselect
            v-model="filter.anosafra"
            label="Selecione o Ano Safra"
            :multiple="true"
            :required="true" 
            :closeOnSelect="false"
            @select="errorAnoSafra.descricao = null"
          />
           <div v-if="errorAnoSafra.descricao " class="invalid-feedback" style="display: block;">
              {{ errorAnoSafra.descricao }}
          </div> 
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Selecione um Estado</label>
          <multiselect
            v-model="filter.state"
            :close-on-select="false"          
            :loading="loading.states"
            :options="states"
            placeholder="Selecionar o Estado"
            :multiple="true"
            :limit="3"
            :limit-text="limitText"
            label="name"
            track-by="id"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Cidade</label>
          <multiselect
            v-model="filter.county"
            :close-on-select="false"           
            :loading="loading.counties"
            :options="counties"
            placeholder="Selecionar Cidade"
            :multiple="true"
            :limit="1"
            :limit-text="limitText"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Filial</label>
          <multiselect
            v-model="filter.branch"
            :close-on-select="false"           
            :loading="loading.branches"
            :options="branches"
            placeholder="Selecionar Filial"
            label="name"
            track-by="id"
            :multiple="true"
            :limit="1"
            :limit-text="limitText"
            @search-change="debouncedInitBranches"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Selecione o Gerente Comercial</label>
          <multiselect
            v-model="filter.manager"
            :loading="loading.managers"
            :options="managers"
            placeholder="Selecionar o Gerente Comercial"
            label="name"
            track-by="id"
            :multiple="true"
            :limit="1"
            :limit-text="limitText"
            @search-change="debouncedInitManagers"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Selecione o Vendedor</label>
          <multiselect
            v-model="filter.salesman"
            :close-on-select="false"  
            :loading="loading.salesmans"
            :options="salesmans"
            placeholder="Selecionar Vendedor"
            label="name"
            :multiple="true"
            track-by="id"
            :limit="1"
            :limit-text="limitText"
            @search-change="debouncedInitSalesmen"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Selecione o Cliente</label>
          <multiselect
            v-model="filter.client"
            :close-on-select="false"           
            :loading="loading.clients"
            :options="clients"
            placeholder="Selecionar o Cliente"
            label="name"
            track-by="id"
            :multiple="true"
            :limit="1"
            :limit-text="limitText"
            @search-change="debouncedInitClients"
          />
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <label class="form-control-label">Selecione Cultura</label>
          <multiselect
            v-model="cultureName"
            :close-on-select="false"  
            :loading="loading.cultures"
            :options="cultures"
            placeholder="Selecionar Cultura"
            label="description"
            :multiple="true"
            :limit="2"
            :limit-text="limitText"
            track-by="id"
            @search-change="debouncedInitCultures"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-6 col-md-2">
          <base-button type="secondary" style="width: 100%; margin-top: 28px;" @click="clearFilters">Limpar Filtros</base-button>
        </div>
        <div class="col-12 col-sm-6 col-md-2">
          <base-button color="red" type="neutral" @click="downloadPdf()" style="width: 100%; margin-top: 28px;" class="text-red mb-2" >
            Gerar PDF<i class="fa fa-file-pdf"></i>
          </base-button>
        </div>
        <div class="col-12 col-md-2">
          <base-button type="primary" style="width: 100%; margin-top: 28px;" @click="filterAnosafra">Filtrar</base-button>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 col-sm-12 col-md-6 mb-4" v-loading="loading.map">
          <svg-map v-model="selectLocation" :map="Brazil" @mouseover="pointLocation" @mouseout="unpointLocation"  @mousemove="moveOnLocation"/>
          <div id="svg-map-tooltip" :style="tooltipStyle" v-html="pointedLocation"></div>
        </div>
        <div class="col-12 col-sm-12 col-md-6">
          <div class="row">
            <div class="col">
              <div class="card p-3">
                <div class="card-title d-flex  flex-row justify-content-between">
                  <p class="h4">Area total de cultura</p>
                  <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-info">
                    <i class="fa fa-leaf"></i>
                  </div>
                </div>
                <div class="card-body p-0" v-loading="loading.totalArea">
                  <p class="h2">
                    {{ parseFloat(cultureAmountByState && cultureAmountByState.culture_area || 0).toLocaleString() }} ha
                  </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card p-3">
                <div class="card-title d-flex  flex-row justify-content-between">
                  <p class="h4">Area total da Propriedade</p>
                  <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green">
                    <i class="fa fa-home"></i>
                  </div>
                </div>
                <div class="card-body p-0" v-loading="loading.totalArea">
                  <p class="h2">
                    {{
                      parseFloat(cultureAmountByState && cultureAmountByState.client_properties_area || 0).toLocaleString('pt-BR')
                    }} ha
                  </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card p-3">
                <div class="card-title d-flex  flex-row justify-content-between">
                  <p class="h4">Potencial Total de Cultura</p>
                  <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green">
                    <i class="fa fa-dollar-sign"></i>
                  </div>
                </div>
                <div class="card-body p-0" v-loading="isLoading">
                  <p class="h2">
                    {{
                      totalCulturePotential.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="card p-3">
                <div class="card-title d-flex  flex-row justify-content-between">
                  <p class="h4">Percentual de participação Vegetal</p>
                  <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green">
                    <i class="fa fa-percent"></i>
                  </div>
                </div>
                <div class="card-body p-0" v-loading="isLoading">
                  <p class="h2">
                    {{
                      percentageParticipationVegetal.toLocaleString('pt-br', { 
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      })
                    }}%
                  </p>
                </div>
              </div>
            </div>

          </div>
          <div class="row">
            <div class="col">
              <el-table v-loading="isLoading" :data="cultureData" class="table-striped" height="400"
                header-row-class-name="thead-light" style="width: 100%;">
                <el-table-column label="Cultura" prop="culture_name" v-slot="{ row }" min-width="110" sortable>
                  {{ row.culture_name }}
                </el-table-column>
                <el-table-column label="Area Cultura" prop="culture_area" v-slot="{ row }" min-width="140" sortable>
                  {{ parseFloat(row.culture_area || 0).toLocaleString("pt-BR") }}
                </el-table-column>
                <el-table-column label="Area terreno" prop="area_propriedade" v-slot="{ row }" min-width="140" sortable>
                  {{ parseFloat(row.area_propriedade || 0).toLocaleString("pt-BR") }}
                </el-table-column>
                <el-table-column label="UF" prop="uf" v-slot="{ row }" sortable>
                  {{ row.uf }}
                </el-table-column>
                <el-table-column label="Potencial de Cultura" prop="potencial_cultura" v-slot="{ row }" min-width="190" sortable>
                  {{
                    row.culture_potential.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "brl",
                    })
                  }}
                </el-table-column>
                <el-table-column label="Participação Vegetal" prop="" v-slot="{ row }" min-width="225" sortable>
                  {{
                    row.vegetal_participation.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "brl",
                      })
                    }}
                </el-table-column>
              </el-table>
              <div class="card-footer py-4 d-flex justify-content-end">
                <base-pagination v-on:input="changePage" v-model="paginated_data.current" :total="paginated_data.count"
                  :perPage="paginated_data.per_page">
                </base-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
  import { SvgMap } from "vue-svg-map"
  import PageTitle from "@/layouts/PageTitle";
  import Brazil from "@svg-maps/brazil"
  import Multiselect from "@/components/Multiselect/translated_multiselect.vue"
  import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";
  import {
    Table,
    TableColumn
  } from "element-ui";
  export default {
    name: 'CultureByStates',
    components: {
      SvgMap,
      PageTitle,
      Multiselect,
      AnosafraMultiselect,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    data() {
      return {
        Brazil,
        isLoading: false,
        mapData: [],
        cultureData: [],
        cultures: [],
        percentageParticipationVegetal: 0,
        totalCulturePotential: 0,
        culture: null,
        cultureAmountByState: 0,
        cultureAmountTooltip:0,
        selectLocation: null,
        selectedStates: [],
        filteredStates: [],
        salesmans: [],
        anosafras: [],
        managers: [],
        states: [],
        errorAnoSafra: {},
        clients: [],
        counties: [],
        branchesRequestIndex: 1,
        branches: [],
        pointedLocation: null,
        tooltipStyle: null,
        location: null,
        filter: {
          cultures: [],
          salesman: [],
          anosafra: [],
          manager: [],
          client: [],
          state: [],
          county: [],
          branch: [],
        },
        hashColors: {
          fill: "#00f880",
          click: "#08d011",
          noData: "#E1E1E1"
        },
        debounceTime: null,
        paginated_data: {
          current: 1,
          count: 0,
          per_page: 10
        },
        loading: {
          totalArea: false,
          map: false,
          anosafras: false,
          managers: false,
          salesmans: false,
          cultures: false,
          clients: false,
          states: false,
          counties: false
        },
        cache: {},
        salesmenSearchTimeout: null,
        clientsSearchTimeout: null,
        managersSearchTimeout: null,
        initCulturesSearchTimeout: null,
        updateFiltersTimeout: null,
        branchesSearchTimeout: null,
        filterMethodsDict: {
          branches: this.initBranches,
          salesmen: this.initSalesman,
          managers: this.initManagers,
          states:   this.loadStatesOptions,
          counties: this.initCounty,
          clients:  this.initClients,
          cultures: this.initCultures,
        } 
      }
    },
    methods: {
      validateForm() {
        this.errorAnoSafra = {};

        if (!this.filter.anosafra || this.filter.anosafra.length == 0) this.errorAnoSafra.descricao   = " Campo Anosafra é obrigatório."
        if (Object.keys(this.errorAnoSafra).length > 0) return false;
        
        return true;
      },
      async getCulturesByState() {
        this.loading.map = true
        try {
          const response = await this.$http.secured.get("/api/v1/ufs_with_culture", {
            params: this.filterParams
          })

          this.loading.map = false
          return response.data
        } catch (error) {
          console.warn("[CultureByStates] - getCulturesByState", error)
        }
        this.loading.map = false
        return []
      },
      fillMap() {
        const location = Brazil.__ob__.dep.subs[1].vm.$el.children
        for (let i = 0; i < location.length; i++) {
          if (this.filteredStates.includes(location[i].id.toUpperCase())) {
            location[i].style.fill = this.hashColors['fill']
            location[i].style.cursor = "pointer"
          } else {
            location[i].style.fill = this.hashColors["noData"]
            location[i].style.cursor = "not-allowed"
          }
        }
      },
      async loadStatesOptions() {
        const { uf, ...filterParams } = this.filterParams
        this.loading.states = true;
        try {
          const response = await this.$http.secured.get("/api/v1/ufs_with_culture", {
            params: filterParams
          });

          this.states = response.data.map(uf => ({
            id: uf,
            name: uf.toUpperCase()
          }));
          this.loading.states = false;
        } catch (error) {
          console.warn("[CultureByStates] - loadStatesOptions", error);
        }
      },
      loadStates(data) {
        this.filteredStates = data
      },
      async getTotalAreaData() {
        this.loading.totalArea = true;

        try {
          const response = await this.$http.secured.get("/api/v1/culture_id_dashboard_data", {
            params: this.filterParams
          });

          this.cultureAmountByState = response.data || {};
        } catch (error) {
          console.warn("[CultureByStates] - getTotalAreaData", error);
        }

        this.loading.totalArea = false;
      },
      async getReportData() {
        this.isLoading = true

        try {
          const response = await this.$http.secured.get("/api/v1/cultures_by_uf/", {
            params: {
              page: this.paginated_data.current,
              ...this.filterParams
            }
          })

          this.cultureData = response.data.culture_ids && response.data.culture_ids.culture_ids || []
          this.paginated_data = response.data.culture_ids
          this.totalCulturePotential = response.data.total_culture_potential;
          this.percentageParticipationVegetal = response.data.percentage_participation_vegetal;
        } catch (error) {
          console.warn("[CultureByStates] - getCultures", error)
        }

        this.isLoading = false
      },
      async initCultures(query = null) {
        this.loading.cultures = true
        const { culture_id, ...filterParams } = this.filterParams
        const q = filterParams

        if (query) q.description = query;

        try {
          const response = await this.$http.secured.get("/api/v1/cultures", {
            params: {
              q: q
            }
          })

          this.cultures = response.data.cultures
        } catch (error) {
          console.warn("[CultureByStates] - getCultures", error)
        }
        this.loading.cultures = false
      },
      changePage() {
        this.getReportData(this.location)
      },
      async clearFilters() {
        this.isLoading = true
        this.cultures = []
        this.culture = {}
        this.filter.state = []
        this.filter.county = []
        this.filter.branch = []
        this.filter.salesman = []
        this.filter.manager = []
        this.filter.anosafra = []
        this.filter.client = []
        this.isLoading = false
        this.selectedStates = [];
        this.location = null;
        this.fillMap();
        this.getReportData()
        this.cache = {};
      },
      limitText(count) { 
        return `+ ${count}`;
      },
      async initSalesman(query = null) {
        this.loading.salesmans = true
        const { salesman_id, branch_id, name, ...queryObj } = this.filterParams;

        queryObj.salesman_branch_id = branch_id

        if (query) queryObj.name = query;

        try {
          const response = await this.$http.secured.get("/api/v1/users",
            {
              params: {
                page: 1,
                per_page: 20,
                q: { is_salesman: true, ...queryObj }
              }, 
            })
          this.salesmans = response.data && response.data.users || [];
          console.log('vendedores do ano safra atual:', this.salesmans);
        } catch (error) {
          console.warn("[CultureByStates] - initSalesman", error)
        }
        this.loading.salesmans = false
      },
      async initManagers(query = null) {
        this.loading.managers = true
        const { manager_id, branch_id, ...queryObj } = this.filterParams;

        queryObj.manager_branch_id = branch_id

        if (query) queryObj.name = query;

        try {
          const response = await this.$http.secured.get("/api/v1/users", {
            params: {
              page: 1,
              per_page: 20,
              q: {is_manager: true, queryObj}
            }
          });
          this.managers = response.data && response.data.users || [];
        } catch (error) {
          console.warn("[CultureByStates] - initManagers", error)
        }
        this.loading.managers = false
      },
      filterAnosafra(){
        this.paginated_data.current = 1

        if (!this.validateForm()) {
          return;
        }

        this.getReportData(); 
        this.getTotalAreaData()
      },
      async clientRequest(countyOnly = null, query = null) {

        const { anosafra_id, client_id, manager_id, ...filterParams } = this.filterParams

        const data = {
          page: 1,
          per_page: 20,
          q: { id: client_id, ...filterParams }
        };

        if (anosafra_id) {
          data.q.anosafra_ids = anosafra_id
        }

        if (manager_id) {
          data.q.manager_ids = manager_id
        }

        if (countyOnly) {
          data.county_only = true

          if (this.filter.client && this.filter.client.length > 0) {
            data.q.id = this.filter.client.map((client) => client.id);
          }
        }

        if (query) {
          data.q.name = query
        }

        try {
          return await this.$http.secured.get("/api/v1/clients", { params: data })
        } catch (error) {
          console.warn("[CultureByStates] - initClients", error)
        }
      },
      async initClients(query = null) {
        this.loading.clients = true
        
        try {
          const response = await this.clientRequest(false, query)
          this.clients = response.data && response.data.clients || [];
        } catch (error) {
          console.warn("[CultureByStates] - initClients", error)
        } finally {
          this.loading.clients = false
        }
      },
      async initCounty (){
        this.loading.counties = true

        try {
          const response = await this.clientRequest(true)
          this.counties = response.data
        } catch (error) {
          console.warn("[CultureByStates] - initClients", error)
        } finally {
          this.loading.counties = false
        }
      },
      async initBranches(query = null) {
        this.loading.branches = true;
        this.branchesRequestIndex += 1;
        const currentRequestIndex = this.branchesRequestIndex;

        const { branch_id, ...data } = this.filterParams

        if (query) data.name = query;
      
        try {
          const responseBranches = await this.$http.secured.get("/api/v1/branches",{
            params: { q: data }
          });

          if (this.branchesRequestIndex !== currentRequestIndex) return

          this.branches = responseBranches.data; 
        } catch (error) {
          console.warn("[CultureByStates] - getCulturesByState", error);
        } finally {
          this.loading.branches = false;
        }
      },
      pointLocation(event) {
        if (this.filteredStates.includes(event.target.attributes[0].value.toUpperCase())) {
          this.updateTooltipValue(event);
        }
      },
      unpointLocation() {
        this.pointedLocation = null
        this.tooltipStyle = { display: 'none' }
      },
      moveOnLocation(event) {
        if (this.filteredStates.includes(event.target.attributes[0].value.toUpperCase())) {
          this.tooltipStyle = {
            position: 'fixed',
            display: 'block',
            top: `${event.clientY - 100}px`,
            left: `${event.clientX - 50}px`,
          }
        }
      },
      async updateTooltipValue(event) {
        this.pointedLocation = "Carregando...";
        let mapUf = event.target.attributes[0].value.toUpperCase();
        const { uf, ...filterParams } = this.filterParams
        const ufForCache = mapUf;
        const culturesCacheKey  = this.filter.cultures.map((el) => el.id).sort((a,b) => a > b)
        const anosafrasCacheKey = this.filter.anosafra.map((el) => el.id).sort((a,b) => a > b)
        const managesCacheKey   = this.filter.manager.map((el) => el.id).sort((a,b) => a > b)
        const clientsCacheKey   = this.filter.client.map((el) => el.id).sort((a,b) => a > b)
        const salesmansCacheKey = this.filter.salesman.map((el) => el.id).sort((a,b) => a > b)

        const cacheKey = `${ufForCache}-${culturesCacheKey}-${anosafrasCacheKey}-${managesCacheKey}-${clientsCacheKey}-${salesmansCacheKey}`;

        if (this.cache[cacheKey]) {
          this.cultureAmountTooltip = this.cache[cacheKey];
          this.displayTooltip(event);
          return;
        }

        try {
          const response = await this.$http.secured.get("/api/v1/culture_id_dashboard_data", {
            params: { uf: mapUf, ...filterParams }
          });

          if (response.data) {
            this.cultureAmountTooltip = response.data;
            this.cache[cacheKey] = response.data;
            this.displayTooltip(event);
          } else {
            this.pointedLocation = `
              ${event.target.attributes[1].value}<br>
              Não possui
            `;
          }
        } catch (error) {
          console.warn("[CultureByStates] - updateTooltipValue", error);
          this.pointedLocation = `
            ${event.target.attributes[1].value}<br>
            Erro ao carregar dados
          `;
        }
      },
      displayTooltip(event) {
        let formattedValue = parseFloat(this.cultureAmountTooltip.culture_area || 0).toLocaleString("pt-BR") + " ha";
        var sumTotalValue = this.cultureAmountTooltip.total_value_sum;

        this.pointedLocation = `
        ${event.target.attributes[1].value}<br>
        Área cultivada: ${formattedValue}
        <br>
        Potencial de cultura: ${parseFloat(sumTotalValue).toLocaleString("pt-BR", { maximumFractionDigits: 2 })}
        `;
      },
      async downloadPdf() {
        const response = await this.$http.secured.get("/api/v1/culture_by_state_pdf", {
          responseType: 'arraybuffer',
          params: {
            uf: this.filter.state.map(state => state.id),
            ...this.filterParams
          }
        })
        this.savePdf(response.data)
      },
      savePdf(newBlob) {
        const blob = new Blob([newBlob], { type: 'application/pdf' })

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Culturas_por_Estado.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      debouncedInitSalesmen(params) {
        if (this.salesmenSearchTimeout) clearTimeout(this.salesmenSearchTimeout);

        this.salesmenSearchTimeout = setTimeout(() => {
         this.initSalesman(params)
        }, 500);
      },
      debouncedInitManagers(params) {
        if (this.managersSearchTimeout) clearTimeout(this.managersSearchTimeout);

        this.managersSearchTimeout = setTimeout(() => {
         this.initManagers(params)
        }, 500);
      },
      debouncedInitClients(params) {
        if (this.clientsSearchTimeout) clearTimeout(this.clientsSearchTimeout);

        this.clientsSearchTimeout = setTimeout(() => {
         this.initManagers(params)
        }, 500);
      },
      debouncedInitBranches(params) {
        if (this.branchesSearchTimeout) clearTimeout(this.branchesSearchTimeout);

        this.branchesSearchTimeout = setTimeout(() => {
         this.initManagers(params)
        }, 500);
      },
      debouncedInitCultures(params) {
        if (this.initCulturesSearchTimeout) clearTimeout(this.initCulturesSearchTimeout);

        this.initCulturesSearchTimeout = setTimeout(() => {
         this.initManagers(params)
        }, 500);
      },
      updateFilters(keys) {
        if (this.updateFiltersTimeout) clearTimeout(this.updateFiltersTimeout);

        this.updateFiltersTimeout = setTimeout(() => {
          keys.forEach((key) => this.filterMethodsDict[key].call())
        }, 500)
      },
    },
    async mounted() {
      this.filter.anosafra = [this.$store.state.currentAnosafra];
      this.mapData = await this.getCulturesByState()
      this.loadStates(this.mapData)
      this.getReportData()
      this.getTotalAreaData()
      this.fillMap()
      this.updateFilters(['states', 'counties', 'branches', 'managers', 'salesmen', 'clients', 'cultures'])
    },
    watch:{
      'filter.state': function () {
        this.updateFilters(['counties', 'branches', 'managers', 'salesmen', 'clients', 'cultures'])
      },
      'filter.county': function () {
        this.updateFilters(['states', 'branches', 'managers', 'salesmen', 'clients', 'cultures'])
      },
      'filter.branch': function () {
        this.updateFilters(['states', 'counties', 'managers', 'salesmen', 'clients', 'cultures'])
      },
      'filter.manager': function () {
        this.updateFilters(['states', 'counties', 'branches', 'salesmen', 'clients', 'cultures'])
      },
      'filter.salesman': function () {
        this.updateFilters(['states', 'counties', 'branches', 'managers', 'clients', 'cultures'])
      },
      'filter.client': function () {
        this.updateFilters(['states', 'counties', 'branches', 'managers', 'salesmen', 'cultures'])
      },
      'filter.cultures': function () {
        this.updateFilters(['states', 'counties', 'branches', 'managers', 'salesmen', 'clients'])
      },
      'filter.anosafra': function () {
        this.updateFilters(['states', 'counties', 'branches', 'managers', 'salesmen', 'clients', 'cultures'])
      },
    },
    computed: {
      filterParams() {
        return {
          ...(this.filter.state && this.filter.state.length       ? { uf: this.filter.state.map((state) => state.id) } : {}),
          ...(this.filter.cultures && this.filter.cultures.length ? { culture_id: this.filter.cultures.map((culture) => culture.id) } : {}),
          ...(this.filter.manager && this.filter.manager.length   ? { manager_id: this.filter.manager.map(manager => manager.id) } : {}),
          ...(this.filter.client && this.filter.client.length     ? { client_id: this.filter.client.map(client => client.id) } : {}),
          ...(this.filter.salesman && this.filter.salesman.length ? { salesman_id: this.filter.salesman.map(salesman => salesman.id) } : {}),
          ...(this.filter.branch && this.filter.branch.length     ? { branch_id: this.filter.branch.map(branch => branch.id) } : {}),
          ...(this.filter.anosafra && this.filter.anosafra.length ? { anosafra_id: this.filter.anosafra.map(anosafra => anosafra.id) } : {}),
          ...(this.filter.county && this.filter.county.length ? { county: this.filter.county } : {}),
          
        }
      }
    }
  }

</script>
<style src="vue-svg-map/dist/index.css"></style>
<style scoped lang="scss">
  #svg-map-tooltip {
    background-color: rgba(255, 255, 255, 0.87);
    backdrop-filter: blur(10px);
    padding: 5px 10px;
    border-radius: 5px;
    -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
    z-index: 999
  }
  #svg-map-tooltip::before {
    content: " ";
    position: bottom;
    width: 0;
    height: 0;
    border-width: 10px 10px 0 10px;
    border-color: rgba(255, 255, 255, 0.87) transparent transparent transparent;
    backdrop-filter: blur(10px);
    bottom: -10px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
</style>
